import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfVideoList, { EfVideoListItemProps } from '@elem/ui/ef-video-list';

export default function TheComp() {
    const listUsers: EfVideoListItemProps[] = [
        {
            pc: 'https://www.ecoflow.com/responsive/picture/delta-pro-ultra/launch/media0.jpg',
            src: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
            title: 'Off Grid Stackable Solar Battery - So easy its *Almost* Cheating...',
        },
        {
            pc: 'https://www.ecoflow.com/responsive/picture/delta-pro-ultra/launch/media0.jpg',
            src: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
            title: 'Off Grid Stackable Solar Battery - So easy its *Almost* Cheating...',
        },
        {
            pc: 'https://www.ecoflow.com/responsive/picture/delta-pro-ultra/launch/media0.jpg',
            src: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
            title: 'Off Grid Stackable Solar Battery - So easy its *Almost* Cheating...',
        },
        {
            pc: 'https://www.ecoflow.com/responsive/picture/delta-pro-ultra/launch/media0.jpg',
            src: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
            title: 'Off Grid Stackable Solar Battery - So easy its *Almost* Cheating...',
        },
    ];
    return (
        <div id="VideoListA">
            <EfSpec />
            <EfTitle>title</EfTitle>
            <EfVideoList list={listUsers} />
        </div>
    );
}
